import { ChangeEvent } from "react";
import { makeStyles } from "tss-react/mui";
import { FormControlLabel, Switch, SxProps, Theme } from "@mui/material";

interface MiSwitchProps {
  label?: string;
  name?: string;
  value: boolean | string | number | undefined | null;
  handleChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
  disabled?: boolean;
  className?: string;
  sx?: SxProps<Theme>;
  slotProps?: Record<string, unknown>;
}

export function MiSwitch({
  label = "",
  name = "",
  value,
  handleChange,
  disabled = false,
  className,
  sx,
  slotProps,
}: MiSwitchProps) {
  const { classes, cx } = useStyles();

  return (
    <FormControlLabel
      className={cx(classes.switch, className)}
      data-testid={`mi-switch-${name}`}
      control={<Switch checked={!!value} onChange={handleChange} />}
      label={label}
      disabled={disabled}
      sx={sx}
      slotProps={slotProps}
    />
  );
}

const useStyles = makeStyles()(() => ({
  switch: {
    width: "100%",
    margin: 0,
  },
}));
